import { gql } from "@apollo/client";

export const GET_POST_SLUGS = gql`
  query Posts($cursor: String!) {
    posts(first: 10, after: $cursor) {
      nodes {
        slug
      }
      pageInfo {
        hasPreviousPage
        hasNextPage
        endCursor
      }
    }
  }
`;

export const GET_POSTS = gql`
  query Posts($first: Int, $last: Int, $after: String!, $before: String!) {
    posts(first: $first, last: $last, after: $after, before: $before) {
      nodes {
        title
        slug
        uri
        excerpt
        featuredImage {
          node {
            altText
            sourceUrl
          }
        }
        author {
          node {
            name
            uri
          }
        }
        categories {
          nodes {
            name
            uri
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

export const GET_POSTS_BY_CATEGORY = gql`
  query Categories(
    $slug: ID!
    $first: Int
    $last: Int
    $after: String!
    $before: String!
  ) {
    category(idType: SLUG, id: $slug) {
      id
      posts(first: $first, last: $last, after: $after, before: $before) {
        nodes {
          title
          slug
          uri
          excerpt
          featuredImage {
            node {
              altText
              sourceUrl
            }
          }
          author {
            node {
              name
              uri
            }
          }
          categories {
            nodes {
              name
              uri
            }
          }
        }
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
      }
    }
  }
`;
